module.exports = __webpack_public_path__ + "static/img/mf.be719cf2.svg";